import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import TopPromoBar from './components/TopPromoBar';
import { useLang } from './i18n';

export default function Layout() {
  const { lang } = useLang();
  return (
    <div className="app" dir="rtl" lang={lang}>
      <TopPromoBar />
      <Header />
      <main className="app-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
